<figure>
  @if (dataSignal().img && dataSignal().img !== null) {
  <a class="flex cursor-pointer" tabindex="0" [routerLink]="[`/${ROUTER_TOKENS.BRANCHES}/detail`, dataSignal().id]">
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title || 'รูปภาพสาขา'"
      [title]="dataSignal().title || 'รูปภาพสาขา'"
      class="item-image"
      loading="lazy"
    />
  </a>
  } @else {
  <div class="item-image"></div>
  }
  <figcaption>
    <h2 class="font-size-26 font-weight-bold title-address line-clamp-2 cursor-default">{{ dataSignal().title }}</h2>
    <div class="container-address">
      @if(dataSignal().address){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">home</mat-icon>
        </div>
        <p class="font-size-16 cursor-default">{{ dataSignal().address }}</p>
      </div>
      } @if(dataSignal().phone){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">phone</mat-icon>
        </div>
        <a href="tel:{{ dataSignal().phone }}" class="font-size-16">{{ dataSignal().phone }}</a>
      </div>
      } @if(dataSignal().email){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">mail</mat-icon>
        </div>
        <a href="mailto:{{ dataSignal().email }}" class="font-size-16">{{ dataSignal().email }}</a>
      </div>
      } @if(isMock){
      <a
        class="item-location"
        (click)="onClickLocationBranch(dataSignal().lat, dataSignal().lng)"
        tabindex="0"
        (keydown)="onClickLocationBranch(dataSignal().lat, dataSignal().lng)"
      >
        เส้นทางการเดินทาง
      </a>
      }
    </div>
  </figcaption>
</figure>
